export const bannerReviewConst = {
    title: 'Banner Reviews',
    imageUploadBtn1: "Pic Of Client",
    imageUploadBtn2: "Upload Pic",
    save: "Save",
    delete: "Delete",

    completed: "completed",

    bannerAddSuccess: 'Banner review added successfully',
    bannerAddFailed: 'Failed to add banner review',
    bannerUpdateSuccess: 'Banner review updated successfully',
    bannerUpdateFailed: 'Failed to update banner review',

    deleteSucess: "Banner review deleted successfully",
    deleteFailed: "Failed to delete banner review",
    deleteConfirm: 'Are you sure you want to delete this banner review?',
    deleteHead: 'Confirm Delete',
    deleteOk: 'Delete',
    deleteCancel: 'Cancel',

    edit: "Edit",
    success: "success",
    failed: "failed",

    validationMsge: "Please select image or enter description to proceed",
    validationImgMsg: "Please select image to proceed",
    validationDescMsg: "Please enter description to proceed"
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/banner-reviews.ts